module.exports = __webpack_public_path__ + "static/3-2c3aa002f27a501462c4e566d74a9a0d.jpg";